import axios from "axios";
import Cookies from "js-cookie"
import { handleLogout } from "../helpers/common.helpers";

const HOST = process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD;

// "http://localhost:5001";

// Create a new Axios instance
const api = axios.create({
  baseURL: "/api-proxy",
  // withCredentials: true,
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
});

// Add a request interceptor to send refresh token if present
// if (rfTkn) {
api.interceptors.request.use((config) => {
  // Access refresh token from cookies dynamically for each request
  const rfTkn = Cookies.get("token");

  // 🔐 Generate secure timestamp key
  const secretKey = process.env.REACT_APP_AUTH_SHARED_SECRET;
  const randomKey = Math.random().toString(36).substring(2, 12);
  const timestamp = Date.now().toString();
  const rawKey = `${secretKey}:${randomKey}:${timestamp}`;
  const encodedKey = btoa(rawKey); // Base64 encode

  // Add mandatory headers
  config.headers["page-index"] = encodedKey;

  // 🔍 Debug logging
  console.group("Axios Request Debug");
  console.log("URL:", config.url);
  console.log("Page-Index Header:", encodedKey);
  console.log("Auth Token (Cookies):", rfTkn);
  console.groupEnd();

  if (rfTkn) {
    config.headers["Authorization"] = rfTkn;
  }

  // Handle Content-Type for FormData
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  } else if (!config.headers["Content-Type"]) {
    config.headers["Content-Type"] = "application/json";
  }

  return config
})


// Add a response interceptor
api.interceptors.response.use(
  (response) => {
    // If the response was successful, there's no need to do anything
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // If the server returned a 401 status (unauthorized). if the message is not token error and this is not a retry request,
    // then refresh the token and retry the request
    if (
      error.response?.status === 401 &&
      error.response?.data?.message !== "Token Error" &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      // Retry the original request
      return api(originalRequest);
    }

    // If the error was still 401 after retry or it's a definitive Token Error, logout
    if (error.response?.status === 401) {
      handleLogout();
    }

    // If the error was not 401 or this was a retry request, reject the promise
    return Promise.reject(error);
  }
);

export default api;
